// extracted by mini-css-extract-plugin
export default {"completed":"Task_completed__Di57x"};